import { Stack } from '@mui/material';

import { api } from 'common';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import {
  ParentBlockSelectField,
  getSourceBlockNameHelperText,
} from '../../../ConfigFields/SelectField';

const PatientDataStore = api.FlowDefinition.PatientDataStore;

export const PractitionersVariant = {
  schema: PatientDataStore.PractitionersConfigSchema,
  Config: () => {
    return (
      <Stack spacing={2}>
        <ParentBlockSelectField
          fieldName="config.practitionerFilters.provider.sourceBlockName"
          label="Provider Source"
          helperText={getSourceBlockNameHelperText('provider')}
        />
        <BlockValueTemplateField
          fieldName="config.practitionerFilters.npi"
          label="NPI"
          helperText="Provider NPI, leave blank if provider source is provided, e.g. {{provider.data.npi}} or 1234567890"
        />
      </Stack>
    );
  },
};
